import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

export const LoadingOverlay = ({ tip = "Loading..." }) => (
  <div
    style={{
      position: "fixed",
      background: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(4px)",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <Spin indicator={<LoadingOutlined />} tip={tip} size="large" />
  </div>
);
